/**
 * Mock Feed Data for Testing
 * Set USE_MOCK_DATA=false in usePracticePulse to use real API
 */

export const mockDentalNews = [
  {
    id: 'news-001',
    source: 'dental_news',
    category: 'news',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    title: 'New Study: AI-Assisted Diagnostics Improve Cavity Detection by 40%',
    titleHe: '\u05DE\u05D7\u05E7\u05E8 \u05D7\u05D3\u05E9: \u05D0\u05D1\u05D7\u05D5\u05DF \u05D1\u05E2\u05D6\u05E8\u05EA AI \u05DE\u05E9\u05E4\u05E8 \u05D6\u05D9\u05D4\u05D5\u05D9 \u05E2\u05E9\u05E9\u05EA \u05D1-40%',
    summary: 'Researchers at Tel Aviv University demonstrate significant improvements in early cavity detection using machine learning algorithms.',
    summaryHe: '\u05D7\u05D5\u05E7\u05E8\u05D9\u05DD \u05D1\u05D0\u05D5\u05E0\u05D9\u05D1\u05E8\u05E1\u05D9\u05D8\u05EA \u05EA\u05DC \u05D0\u05D1\u05D9\u05D1 \u05DE\u05D3\u05D2\u05D9\u05DE\u05D9\u05DD \u05E9\u05D9\u05E4\u05D5\u05E8 \u05DE\u05E9\u05DE\u05E2\u05D5\u05EA\u05D9 \u05D1\u05D6\u05D9\u05D4\u05D5\u05D9 \u05DE\u05D5\u05E7\u05D3\u05DD \u05E9\u05DC \u05E2\u05E9\u05E9\u05EA.',
    sourceName: 'Dental Tribune',
    sourceUrl: 'https://dental-tribune.com',
    externalUrl: 'https://dental-tribune.com/article/ai-cavity-detection',
    imageUrl: null,
    iconEmoji: '\uD83D\uDCF0',
    likeCount: 12,
    isLiked: false,
    isBookmarked: false,
  },
  {
    id: 'news-002',
    source: 'dental_news',
    category: 'news',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    title: 'Israel Ministry of Health Updates Digital Health Regulations for 2026',
    titleHe: '\u05DE\u05E9\u05E8\u05D3 \u05D4\u05D1\u05E8\u05D9\u05D0\u05D5\u05EA \u05DE\u05E2\u05D3\u05DB\u05DF \u05EA\u05E7\u05E0\u05D5\u05EA \u05D1\u05E8\u05D9\u05D0\u05D5\u05EA \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9\u05EA \u05DC\u05E9\u05E0\u05EA 2026',
    summary: 'New guidelines for AI-powered medical devices in dental practices take effect March 2026.',
    summaryHe: '\u05D4\u05E0\u05D7\u05D9\u05D5\u05EA \u05D7\u05D3\u05E9\u05D5\u05EA \u05DC\u05DE\u05DB\u05E9\u05D9\u05E8\u05D9\u05DD \u05E8\u05E4\u05D5\u05D0\u05D9\u05D9\u05DD \u05DE\u05D5\u05E0\u05E2\u05D9 AI \u05D1\u05DE\u05E8\u05E4\u05D0\u05D5\u05EA \u05E9\u05D9\u05E0\u05D9\u05D9\u05DD \u05E0\u05DB\u05E0\u05E1\u05D5\u05EA \u05DC\u05EA\u05D5\u05E7\u05E3 \u05D1\u05DE\u05E8\u05E5 2026.',
    sourceName: 'MOH Israel',
    sourceUrl: 'https://health.gov.il',
    externalUrl: 'https://health.gov.il/digital-health-2026',
    iconEmoji: '\uD83C\uDFDB\uFE0F',
    likeCount: 28,
    isLiked: true,
    isBookmarked: true,
  },
  {
    id: 'news-003',
    source: 'dental_news',
    category: 'news',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(),
    title: 'Dental Implant Market in Israel Expected to Grow 15% in 2026',
    titleHe: '\u05E9\u05D5\u05E7 \u05D4\u05E9\u05EA\u05DC\u05D5\u05EA \u05D4\u05E9\u05D9\u05E0\u05D9\u05D9\u05DD \u05D1\u05D9\u05E9\u05E8\u05D0\u05DC \u05E6\u05E4\u05D5\u05D9 \u05DC\u05E6\u05DE\u05D5\u05D7 \u05D1-15% \u05D1-2026',
    summary: 'Industry report highlights increasing demand for premium implant solutions.',
    summaryHe: '\u05D3\u05D5\u05D7 \u05EA\u05E2\u05E9\u05D9\u05D9\u05EA\u05D9 \u05DE\u05D3\u05D2\u05D9\u05E9 \u05D1\u05D9\u05E7\u05D5\u05E9 \u05D2\u05D5\u05D1\u05E8 \u05DC\u05E4\u05EA\u05E8\u05D5\u05E0\u05D5\u05EA \u05E9\u05EA\u05DC\u05D9\u05DD \u05E4\u05E8\u05D9\u05DE\u05D9\u05D5\u05DD.',
    sourceName: 'Globes Health',
    sourceUrl: 'https://globes.co.il',
    externalUrl: 'https://globes.co.il/dental-market-2026',
    iconEmoji: '\uD83D\uDCC8',
    likeCount: 5,
    isLiked: false,
    isBookmarked: false,
  },
];

export const mockPracticeActivity = [
  {
    id: 'activity-001',
    source: 'practice_activity',
    category: 'appointment',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
    title: 'Appointment confirmed',
    titleHe: '\u05EA\u05D5\u05E8 \u05D0\u05D5\u05E9\u05E8',
    summary: 'David Cohen confirmed appointment for tomorrow at 10:00',
    summaryHe: '\u05D3\u05D5\u05D3 \u05DB\u05D4\u05DF \u05D0\u05D9\u05E9\u05E8 \u05EA\u05D5\u05E8 \u05DC\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4 10:00',
    iconEmoji: '\u2705',
    actorName: '\u05D3\u05D5\u05D3 \u05DB\u05D4\u05DF',
    actionType: 'appointment_confirmed',
    relatedEntityId: 'APT-20260212-001',
    appointmentDate: '2026-02-12',
    likeCount: 0,
    isLiked: false,
    isBookmarked: false,
  },
  {
    id: 'activity-002',
    source: 'practice_activity',
    category: 'billing',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    title: 'Payment received',
    titleHe: '\u05EA\u05E9\u05DC\u05D5\u05DD \u05D4\u05EA\u05E7\u05D1\u05DC',
    summary: '\u20AA1,200 payment received from Sarah Levi',
    summaryHe: '\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05E1\u05DA \u20AA1,200 \u05D4\u05EA\u05E7\u05D1\u05DC \u05DE\u05E9\u05E8\u05D4 \u05DC\u05D5\u05D9',
    iconEmoji: '\uD83D\uDCB3',
    actorName: '\u05E9\u05E8\u05D4 \u05DC\u05D5\u05D9',
    actionType: 'payment_received',
    relatedEntityId: 'INV-20260211-042',
    likeCount: 0,
    isLiked: false,
    isBookmarked: false,
  },
  {
    id: 'activity-003',
    source: 'practice_activity',
    category: 'patient',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    title: 'New patient registered',
    titleHe: '\u05DE\u05D8\u05D5\u05E4\u05DC \u05D7\u05D3\u05E9 \u05E0\u05E8\u05E9\u05DD',
    summary: 'Yossi Ben-David registered as new patient',
    summaryHe: '\u05D9\u05D5\u05E1\u05D9 \u05D1\u05DF-\u05D3\u05D5\u05D3 \u05E0\u05E8\u05E9\u05DD \u05DB\u05DE\u05D8\u05D5\u05E4\u05DC \u05D7\u05D3\u05E9',
    iconEmoji: '\uD83D\uDC64',
    actorName: '\u05D9\u05D5\u05E1\u05D9 \u05D1\u05DF-\u05D3\u05D5\u05D3',
    actionType: 'patient_registered',
    relatedEntityId: 'PAT-0089',
    likeCount: 0,
    isLiked: false,
    isBookmarked: false,
  },
  {
    id: 'activity-004',
    source: 'practice_activity',
    category: 'appointment',
    priority: 'normal',
    timestamp: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    title: 'Recall sent',
    titleHe: '\u05EA\u05D6\u05DB\u05D5\u05E8\u05EA \u05E0\u05E9\u05DC\u05D7\u05D4',
    summary: 'SMS recall sent to 15 patients for checkup',
    summaryHe: '\u05EA\u05D6\u05DB\u05D5\u05E8\u05EA SMS \u05E0\u05E9\u05DC\u05D7\u05D4 \u05DC-15 \u05DE\u05D8\u05D5\u05E4\u05DC\u05D9\u05DD \u05DC\u05D1\u05D3\u05D9\u05E7\u05D4',
    iconEmoji: '\uD83D\uDCF1',
    actionType: 'recall_sent',
    likeCount: 0,
    isLiked: false,
    isBookmarked: false,
  },
];

export const mockAIAlerts = [
  {
    id: 'ai-alert-001',
    source: 'ai_alert',
    category: 'ai_action',
    priority: 'critical',
    timestamp: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
    title: 'HITL Required: Prescription needs approval',
    titleHe: '\u05E0\u05D3\u05E8\u05E9 \u05D0\u05D9\u05E9\u05D5\u05E8: \u05DE\u05E8\u05E9\u05DD \u05DE\u05DE\u05EA\u05D9\u05DF \u05DC\u05D0\u05D9\u05E9\u05D5\u05E8',
    summary: 'Amoxicillin 500mg prescription for patient requires clinician approval',
    summaryHe: '\u05DE\u05E8\u05E9\u05DD \u05D0\u05DE\u05D5\u05E7\u05E1\u05D9\u05E6\u05D9\u05DC\u05D9\u05DF 500 \u05DE"\u05D2 \u05DC\u05DE\u05D8\u05D5\u05E4\u05DC \u05D3\u05D5\u05E8\u05E9 \u05D0\u05D9\u05E9\u05D5\u05E8 \u05E8\u05D5\u05E4\u05D0',
    iconEmoji: '\uD83E\uDD16',
    aiConfidence: 0.87,
    aiActionId: 'ACT-20260211-0015',
    requiresAction: true,
    likeCount: 0,
    isLiked: false,
    isBookmarked: false,
  },
];

export const mockClinicalWins = [
  {
    id: 'win-001',
    source: 'clinical_win',
    category: 'achievement',
    priority: 'low',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(),
    title: 'Daily goal achieved!',
    titleHe: '\u05D9\u05E2\u05D3 \u05D9\u05D5\u05DE\u05D9 \u05D4\u05D5\u05E9\u05D2!',
    summary: 'Completed 12 treatments today',
    summaryHe: '\u05D4\u05D5\u05E9\u05DC\u05DE\u05D5 12 \u05D8\u05D9\u05E4\u05D5\u05DC\u05D9\u05DD \u05D4\u05D9\u05D5\u05DD',
    iconEmoji: '\uD83C\uDFC6',
    achievementType: 'daily_treatments',
    metric: 12,
    metricLabel: '\u05D8\u05D9\u05E4\u05D5\u05DC\u05D9\u05DD',
    likeCount: 3,
    isLiked: false,
    isBookmarked: false,
  },
];

export const getAllMockFeedItems = () => {
  return [
    ...mockAIAlerts,
    ...mockPracticeActivity,
    ...mockDentalNews,
    ...mockClinicalWins,
  ];
};
